import { W2TSendMessage } from "../components/W2TApps";
import { readDemoSession } from "../lib/session";

/** /dashboard/send — the web2sms send-message component on its own route. */
export function SendMessagePage() {
  const session = readDemoSession();
  return (
    <div className="col-main">
      <p className="w2t-hint">
        Send a real SMS to your verified mobile — it lands straight in your phone's messaging
        app. You have {session.credits} demo sends.
      </p>
      <W2TSendMessage />
    </div>
  );
}
